import { useMemo, useSyncExternalStore } from 'react';
import { EditorCapability, editorRestrictionsStore } from '@/stores/editorRestrictionsStore';

export default function useEditorRestrictions() {
  const { restrictions } = useSyncExternalStore(editorRestrictionsStore.subscribe, editorRestrictionsStore.getSnapshot);

  const blockedCapabilities = useMemo(
    () => new Set<EditorCapability>(Object.values(restrictions).flat()),
    [restrictions]
  );

  const isBlocked = useMemo(
    () => (capability: EditorCapability) => blockedCapabilities.has(capability),
    [blockedCapabilities]
  );

  const isAnyBlocked = useMemo(
    () => (capabilities: EditorCapability[]) => capabilities.some(c => blockedCapabilities.has(c)),
    [blockedCapabilities]
  );

  return { isBlocked, isAnyBlocked };
}
